import React from 'react';
import './CustomModal.css';

const CustomModal = ({
  isOpen,
  type = 'info',
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  showCancel = false
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'confirm':
        return '?';
      default:
        return 'ℹ';
    }
  };

  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'modal-icon-success';
      case 'error':
        return 'modal-icon-error';
      case 'warning':
        return 'modal-icon-warning';
      case 'confirm':
        return 'modal-icon-confirm';
      default:
        return 'modal-icon-info';
    }
  };

  return (
    <div className="custom-modal-overlay" onClick={onCancel}>
      <div className="custom-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className={`custom-modal-icon ${getIconClass()}`}>
          {getIcon()}
        </div>

        {title && <h3 className="custom-modal-title">{title}</h3>}

        <p className="custom-modal-message">{message}</p>

        <div className="custom-modal-buttons">
          {showCancel && (
            <button
              className="custom-modal-btn custom-modal-btn-cancel"
              onClick={onCancel}
            >
              {cancelText}
            </button>
          )}
          <button
            className="custom-modal-btn custom-modal-btn-confirm"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;